import { Box, Flex, Heading, Spinner, Img } from "@chakra-ui/react";
import { FC } from "react";

const AuthAuthorize: FC = () => {
  return (
    <Box bg="green.100" h="100vh" overflowY="auto" color="gray.800">
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        bg="green.900"
        borderRadius="8px"
        h="calc(100vh - 8px)"
        p={6}
      >
        <Flex alignItems="center" justifyContent="center" flexDir="column">
          <Img
            src="https://www.combinegoodz.com/uploads/article/logistics_warehousing.gif"
            width="60%"
          />
          <Heading mb={6} fontSize="40px" color="white" fontWeight="400">
            Aguarde enquanto atualizamos suas credenciais...
          </Heading>
          <Spinner color="yellow.400" width={20} h={20} />
        </Flex>
      </Flex>
    </Box>
  );
};

export default AuthAuthorize;
